export const GETTERS = {
  getUserInsurance: 'getUserInsurance',
};

export default {
  [GETTERS.getUserInsurance](state) {
    return state.currentInsurance;
  },
};
